import { Component, OnInit } from '@angular/core';
import { ProductsService } from './core/services/products/products.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'calypso-web';

  constructor(
    private productsService: ProductsService
  ) { }
  async ngOnInit(): Promise<void> {
    await Promise.all([
      this.productsService.getAllProductsAPINew(),
      this.productsService.getAllCategoriesAPINEW()
    ]);
  }
}
